import { useQuery } from '@tanstack/react-query'
import {
  getAdminReviewStats,
  GetAdminReviewStatsOptions,
  GetAdminReviewStatsResponse,
} from 'api/review'

export function useAdminReviewStats(options: GetAdminReviewStatsOptions) {
  return useQuery<GetAdminReviewStatsResponse>({
    queryKey: ['adminReviewStats', options],
    queryFn: async () => getAdminReviewStats(options),
    enabled: !!options.startDate && !!options.endDate,
  })
}
